import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './zh'
import en from './en'
import cn from './cn'
import es from './es'
import fr from './fr'
import gr from './gr'
import italy from './italy'
import jp from './jp'
import kor from './kor'
import pt from './pt'
import th from './th'
import vi from './vi'
import de from './de'
import india from './india'

let locale = window.localStorage.getItem('lang') || '';
if (locale == '') {
    locale = 'en';
    window.localStorage.setItem('lang', locale);
}
export default new VueI18n({
    locale: locale,
    messages: {
        zh: zh,
        en: en,
        es: es,
        cn: cn,
        fr: fr,
        gr: gr,
        italy: italy,
        jp: jp,
        kor: kor,
        india: india,
        th: th,
        pt: pt,
        vi: vi,
        de: de
    }
})


// WEBPACK FOOTER //
// ./src/lang/lang.js